import { render } from "./GalleryDesignPlate.vue?vue&type=template&id=3bd335ec&scoped=true"
import script from "./GalleryDesignPlate.vue?vue&type=script&lang=js"
export * from "./GalleryDesignPlate.vue?vue&type=script&lang=js"

import "./GalleryDesignPlate.vue?vue&type=style&index=0&id=3bd335ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd335ec"]])

export default __exports__